import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LANGUAGES, changeLanguage } from '../i18n';

interface LanguageSelectorProps {
  className?: string;
}

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({ className = '' }) => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleLanguageChange = (lang: string) => {
    changeLanguage(lang);
    setIsOpen(false);
  };

  // Get current language code
  const currentLanguageCode = i18n.language?.split('-')[0] || 'en';

  return (
    <div className={`relative ${className}`}>
      <button
        type="button"
        className="rounded-md px-2 py-1.5 text-slate-700 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-surface-800"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="text-sm font-medium">{currentLanguageCode.toUpperCase()}</span>
      </button>

      {isOpen && (
        <div className="absolute right-0 z-50 mt-1 w-48 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 dark:bg-surface-800 dark:ring-surface-700">
          <div className="overflow-hidden py-1">
            {Object.entries(LANGUAGES).map(([code, { nativeName }]) => (
              <button
                key={code}
                onClick={() => handleLanguageChange(code)}
                className={`block w-full px-4 py-2 text-left text-sm ${
                  i18n.language === code
                    ? 'bg-slate-100 text-slate-900 dark:bg-surface-700 dark:text-white'
                    : 'text-slate-700 dark:text-slate-300'
                } hover:bg-slate-100 dark:hover:bg-surface-700`}
              >
                {nativeName}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
